@let obs =
  {
    productItemsStock: productItemsStock$ | async,
    productItemsPrice: productItemsPrice$ | async,
  };

<div class="modal-header">
  <h2 class="text-b1-m-900 text-lg-h3-s">Меняете город?</h2>
</div>

<div class="modal-body">
  @if (obs.productItemsPrice.length > 0 && obs.productItemsStock.length === 0) {
    <p class="text-msg text-c1-l-300 text-md-b3-m-300">
      Цены на товары отличаются в выбранном вами городе. Они будут пересчитаны.
    </p>
  } @else {
    <p class="text-msg text-c1-l-300 text-md-b3-m-300">
      Цены на товары отличаются в выбранном вами городе. Некоторые товары отсутствуют или их количество недостаточно.
      Они будут пересчитаны или удалены из корзины
    </p>

    <div class="product-items-stock">
      @for (item of obs.productItemsStock; track item) {
        <sd-compare-cart-product-item [item]="item.entry" [quantity]="item.quantity"></sd-compare-cart-product-item>
      }
    </div>
  }
</div>

<div class="modal-footer">
  <button sdButton [theme]="buttonThemes.Primary" [fullWidth]="true" (click)="confirmNewCart()">изменить</button>
  <button sdButton [theme]="buttonThemes.Secondary" [fullWidth]="true" (click)="closeModal()">не менять</button>
</div>
